import config from "@/site.config.json";

export function NotebookActions({ notebook }: { notebook: { href: string; repoPath: string; filename: string } }) {
  const repositorySet = config.github_org !== "TBD" && config.github_repo !== "TBD";
  const configured = repositorySet && config.github_repo_public;
  const colab = configured
    ? `https://colab.research.google.com/github/${config.github_org}/${config.github_repo}/blob/${config.github_branch}/${notebook.repoPath}`
    : "";
  return (
    <section className="notebook-actions" aria-labelledby="notebook-title">
      <div><p className="eyebrow">Practical lab</p><h2 id="notebook-title">Student notebook</h2><p>Start in Colab when the public repository is connected, or download the notebook and use the course environment.</p></div>
      <div className="button-row">
        {configured ? <a className="button primary" href={colab} target="_blank" rel="noopener">Open in Colab</a> : <span className="button disabled" aria-disabled="true" title="Colab requires a public student repository or explicit access to the private source repository">Colab link pending</span>}
        <a className="button secondary" href={notebook.href} download>Download notebook</a>
      </div>
      {!configured && <p className="config-note">The source repository is private, so public Colab links remain disabled. Download works now; a public student mirror can enable one-click Colab later.</p>}
    </section>
  );
}
